<template>
  <base-dialog
    :visible="dialogVisible"
    width="calc(100vw - 400px)"
    class="ref-data-dialog"
    border-radius="none"
    @open="open"
    @closed="close"
    show-close
  >
    <template v-slot:header>
      <div class="title">
        {{ refSheet.name }}
      </div>
    </template>
    <div class="top-wrap">
      <el-tooltip content="筛选">
        <span
          class="icon-filter"
          :style="{ color: tableFilters.length > 0 ? '#1989FA' : 'unset' }"
          @click="sheetFilterVisible = true"
        >
          <svg-icon icon-class="filter"></svg-icon>
        </span>
      </el-tooltip>
      <field-search
        v-if="dialogVisible"
        ref="fieldSearch"
        :controls="targetSheet.controls"
        @search="searchData($event, 'search')"
      ></field-search>

      <base-button v-if="!hideCreate" type="primary" @click="$refs.editDialog.open()">
        新建并关联
      </base-button>
    </div>
    <ref-sheet-table
      ref="sheetTable"
      :first-level-only="firstLevelOnly"
      :ref-control="control"
      :conditions="[tableFilters, preExcConditions]"
      :show-pointer="!multiple"
      :show-selection="multiple"
      :refCond="refCondition"
      initial-line-height-level="1"
      :row-click-cbk="rowSelected"
      :open-detail="false"
      :delete-visible="false"
      :show-btn-column="false"
      @selection-change="handleSelectionChange"
      @openFilter="openSheetFilter"
      col-filter
    ></ref-sheet-table>
    <div v-if="multiple" class="footer-btn">
      <base-button @click="close">取消</base-button>
      <base-button type="primary" @click="submit">确定</base-button>
    </div>
    <!-- 视图表格数据筛选 -->
    <sheet-filter
      ref="sheetFilter"
      @submit="setTableFilters"
      :dialog-visible.sync="sheetFilterVisible"
      :search-sheet="refSheet"
    ></sheet-filter>
    <!-- 新建关联数据 -->
    <edit-dialog
      ref="editDialog"
      from="reference"
      :sheet-id="control.refSheetId"
      @after-submit="dataCreated"
      :refDataInfo="{
        _ccid: control._ccid,
        data: refSheetData
      }"
    ></edit-dialog>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import { BaseButton } from "@/components/UIComponents"
import SheetFilter from "@/components/UIComponents/SheetFilter"
import FieldSearch from "@/components/Sheet/FieldSearch"
import RefSheetTable from "@/components/UIComponents/SheetTable/RefSheetTable"
import { getSheetViewData } from "@/api/sheet/sheetView"
import { loadingService } from "@/utils/ui"
import { decorateSheet } from "@/utils/sheet"

export default {
  name: "ref-data-dialog",
  components: {
    RefSheetTable,
    BaseDialog,
    SheetFilter,
    BaseButton,
    FieldSearch
  },
  props: {
    dialogVisible: Boolean,
    control: Object,
    refCondition: Object,
    refSheet: Object,
    refSheetData: Object,
    multiple: Boolean,
    hideCreate: Boolean,
    firstLevelOnly: Boolean, // 当树形结构时,是否只展示第一级
    dataIds: Array
  },
  data() {
    return {
      sheetFilterVisible: false,
      select: "",
      input: "",
      tableFilters: [],
      selectedValList: [],
      preExcConditions: []
    }
  },
  beforeCreate() {
    this.$options.components.EditDialog = require("@/components/Sheet/EditDialog").default
  },
  computed: {
    targetSheet() {
      return decorateSheet(this.refSheet)
    }
  },
  methods: {
    open() {
      this.resetSearch()
      this.$nextTick(() => {
        this.$refs.sheetTable.refreshData()
        this.$refs.sheetFilter.fillPreCondition(
          this.control.filters,
          this.refCondition.refSheetData,
          true
        )
        this.preExcConditions = [this.getConditions()]
      })
    },
    getConditions() {
      let existFilter = {}
      if (!this._.isEmpty(this.dataIds)) {
        existFilter.compareMethod = "不包含"
        existFilter.key = "id"
        existFilter.type = "ref"
        existFilter.value = null
        existFilter.varItems = this.dataIds.map(id => ({ var: false, value: id }))
      }
      let refFilter = {}
      let refControl = this.refSheet.controls.find(control => control._cid === this.control._ccid)
      if (refControl?.oneFlag) {
        refFilter.compareMethod = "为空"
        refFilter.key = refControl._cid
        refFilter.type = "ref"
        refFilter.value = null
        refFilter.varItems = []
      }
      return (this._.isEmpty(existFilter) ? [] : [existFilter]).concat(
        this._.isEmpty(refFilter) ? [] : [refFilter]
      )
    },
    close() {
      this.$emit("update:dialogVisible", false)
    },
    setTableFilters(conditions) {
      this.searchData(conditions, "filter")
    },
    searchData(filters, from) {
      this.tableFilters = []
      switch (from) {
        case "search":
          this.resetFilter()
          break
        case "filter":
          this.resetSearch()
          break
      }
      this.tableFilters = filters
    },
    resetSearch() {
      this.$nextTick(() => {
        this.$refs.fieldSearch.reset()
      })
    },
    resetFilter() {
      this.$refs.sheetFilter?.justClear()
    },
    resetAll() {
      this.$nextTick(() => {
        this.$refs.fieldSearch?.reset()
        this.$refs.sheetFilter.justClear()
        this.tableFilters = []
      })
    },
    async handleSelectionChange({ command, length, tableData }) {
      if (command === "全部") {
        let maxNum = 500
        if (length > maxNum) {
          this.$message.error(`数据量过大，请调整筛选条件，使总数在${maxNum}条之内`)
          return
        }
        const loading = loadingService()
        let tableDataResponse = await getSheetViewData({
          sheetId: this.control.refSheetId,
          page: 1,
          size: maxNum,
          conditions: [this.tableFilters],
          ...this.refCondition
        })
        this.selectedValList = tableDataResponse.content
        loading.close()
      } else {
        this.selectedValList = tableData
      }
    },
    rowSelected(data) {
      if (!this.multiple) {
        this.$emit("select", data)
        this.close()
      }
    },
    dataCreated(sheetData) {
      this.resetAll()
      this.$emit("data-created", sheetData, "addRefData")
      this.close()
    },
    submit() {
      this.$emit("submit", this.selectedValList)
      this.close()
    },
    openSheetFilter(col) {
      this.$refs.sheetFilter.addColCondition(col)
      this.sheetFilterVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-data-dialog {
  ::v-deep .el-dialog {
    min-width: 1080px;
    height: 86%;
    color: $color-font-first;
    .title {
      font-size: $font-size-title-second;
      font-weight: bold;
    }
    .el-dialog__headerbtn {
      top: 12px;
    }
    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .top-wrap {
        display: flex;
        align-items: center;
        height: 57px;
        margin: 0 20px;
        .field-search {
          margin-right: 6px;
        }
        .icon-filter {
          color: #535c65;
          font-size: 22px;
          padding: 5px;
          margin-left: -5px;
          margin-right: auto;
          cursor: pointer;
        }
      }
      .sheet-table {
        flex: auto;
        margin-bottom: 8px;
        overflow: hidden;
      }
      .pagination-wrap {
        margin-top: 6px;
      }
      .footer-btn {
        position: absolute;
        right: 20px;
        bottom: 14px;
      }
    }
  }
}
</style>
